/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { ReactElement } from 'react';

/** Brief loading state while report context resolves from URL or custom XML. */
export function LoadingPane(): ReactElement {
  return (
    <div className="ecs-loading-pane" role="status" aria-busy="true" aria-label="Loading">
      <div className="ecs-loading-pane__spinner" aria-hidden="true" />
      <span className="ecs-loading-pane__label">Ecsper</span>
    </div>
  );
}
